import { IPumpPerformanceCurvesParameters } from "./IPumpPerformanceCurvesParameters";

export class PumpPerformanceCurvesParameters implements IPumpPerformanceCurvesParameters
{
    frequencyDataSourceId: number = 0;
    flowRateDataSourceId: number= 0;
    frequencyCorrection: number= 0;
    baseFrequency: number= 0;
    A: number= 0;
    B: number= 0;
    C: number= 0;
    G: number= 0;
    H: number= 0;
    I: number= 0;
    baseBepFlowRate: number = 0;
    fromDate: Date = new Date();
    toDate: Date = new Date();
}